import { User } from '@app/shared/types';

export function getUserLabel(option: User): string {
  return option.email || option.username || '';
}

export function getUserOptionText(option: User): string {
  return option.username
    ? `${option.username} ( ${option.email} )`
    : option.email;
}

export function toOption(email: string, names: Record<string, string>): User {
  return {
    email,
    username: names[email] || email,
    organizations: [],
    isActive: true,
    otherInfo: '',
    attributes: [],
  };
}
